import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { ITitleProps } from '.';

export const generate = (
  props?: Partial<IComponentSchema<ITitleProps>>
): IComponentSchema<ITitleProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.STRING,
    name: props?.name || id,
    title: props?.title || 'Title',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.Title,
    'x-component-props': {
      title: 'Title',
    },
    'x-component-props-config': {},
  };
};
